module.exports = __webpack_public_path__ + "img/google.f6ce5696.svg";